import React from "react";
import { faculty } from "../mock/mock";
import { GraduationCap, BookOpen, Award } from "lucide-react";
import { PageHero } from "./About";

const Faculty = () => {
  return (
    <div>
      <PageHero
        eyebrow="Our Faculty"
        title="Educators who inspire educators"
        subtitle="A dedicated team of academicians, mentors and researchers shaping the next generation of teachers."
        image="https://images.unsplash.com/photo-1680084521816-cc1ad0433ceb"
      />

      <section className="section-y bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {faculty.map((f, i) => (
              <article
                key={f.id}
                className="bg-brand-ivory border border-brand-gold/25 rounded-sm overflow-hidden hover-lift animate-fade-up"
                style={{ animationDelay: `${i * 0.06}s` }}
              >
                <div className="relative h-64 bg-brand-green-deep flex items-center justify-center overflow-hidden">
                  <img src={f.image} alt={f.name} className="w-40 h-40 rounded-full border-4 border-brand-gold shadow-xl" />
                  <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-brand-gold text-brand-green-deep text-[10px] uppercase tracking-widest font-bold">
                    {f.role}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-serif-display text-2xl text-brand-green-deep leading-snug mb-1">{f.name}</h3>
                  <div className="text-sm text-brand-gold-dark font-medium mb-4">{f.subject}</div>
                  <div className="space-y-2 text-sm text-neutral-700 pt-4 border-t border-brand-gold/25">
                    <div className="flex items-center gap-2">
                      <GraduationCap className="w-4 h-4 text-brand-green" />
                      <span>{f.qualification}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Award className="w-4 h-4 text-brand-green" />
                      <span>{f.experience} of teaching experience</span>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section-y bg-brand-ivory">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <BookOpen className="w-12 h-12 text-brand-gold-dark mx-auto mb-6" />
          <h2 className="font-serif-display text-4xl font-bold text-brand-green-deep mb-4">
            Learn from the best, become the best.
          </h2>
          <p className="text-neutral-700 leading-relaxed max-w-2xl mx-auto">
            Our faculty comprises Ph.D. holders, published researchers, and career educators who have collectively contributed
            decades to teacher education. Together they mentor students not just for exams, but for the classrooms and
            communities they will lead.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Faculty;
